import React, { useState } from "react";
import classes from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import {
  IoSettingsOutline,
  IoNewspaperOutline,
  IoHomeOutline,
} from "react-icons/io5";
import { TbPackages } from "react-icons/tb";
import toast from "react-hot-toast";
import { Modal, Button } from "react-bootstrap"; // Import Modal and Button from React Bootstrap

function Footer() {
  const navigator = useNavigate();
  const [showModal, setShowModal] = useState(false); // State for modal visibility

  // Function to handle logout process
  function signOut() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      "Bearer " + localStorage.getItem("token")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("refresh_token", localStorage.getItem("refresh_token"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/user/logout`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("username");
        navigator("/login");
      })
      .catch((error) =>
        toast.error("خطا در خروج رخ داده است دوباره امتحان کنید")
      );
  }

  // Function to handle the modal confirmation for logout
  const handleConfirmLogout = () => {
    setShowModal(false); // Close the modal
    signOut(); // Call the signOut function
  };

  // Function to handle showing the logout confirmation modal
  const handleLogoutClick = () => {
    setShowModal(true); // Show the modal when the logout button is clicked
  };

  // Function to handle canceling logout
  const handleCancelLogout = () => {
    setShowModal(false); // Close the modal without logging out
  };

  return (
    <div className={classes.Footer}>
      <div className={classes.Footer2} onClick={() => navigator("/package")}>
        <TbPackages size={25} />
        <div>پکیج</div>
      </div>
      <div
        className={classes.Footer3}
        onClick={() => navigator("/notification")}
      >
        <IoNewspaperOutline size={25} />
        <div>خبرها</div>
      </div>

      <div className={classes.Footer4} onClick={() => navigator("/")}>
        <IoHomeOutline size={25} />
        <div>خانه</div>
      </div>
      <div className={classes.Footer1} onClick={() => navigator("/setting")}>
        <IoSettingsOutline size={25} />
        <div>تنظیمات</div>
      </div>
      <div className={classes.Footer5} onClick={handleLogoutClick}>
        <FiLogOut size={25} />
        <div>خروج</div>
      </div>

      <Modal
        style={{ direction: "rtl" }}
        show={showModal}
        onHide={handleCancelLogout}
      >
        <Modal.Header>
          <Modal.Title>
            <FiLogOut />
            <span style={{ marginRight: "5px" }}>تأیید خروج</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>آیا مطمئن هستید که می‌خواهید خارج شوید؟</Modal.Body>
        <Modal.Footer>
          <button className="btn btn-outline-dark" onClick={handleCancelLogout}>
            انصراف
          </button>
          <button className="btn btn-danger px-5" onClick={handleConfirmLogout}>
            تأیید
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Footer;
